import { render, staticRenderFns } from "./EnrolmentAgreementViewer.vue?vue&type=template&id=406d1c20&scoped=true"
import script from "./EnrolmentAgreementViewer.vue?vue&type=script&lang=js"
export * from "./EnrolmentAgreementViewer.vue?vue&type=script&lang=js"
import style0 from "./EnrolmentAgreementViewer.vue?vue&type=style&index=0&id=406d1c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d1c20",
  null
  
)

export default component.exports